import React, { useState, useEffect } from 'react';
import { Calculator } from 'lucide-react';
import numbers from '../data/numberEncyclopedia.json';
import LikeButton from './LikeButton';
import ShareButton from './ShareButton';

const NumberFacts = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const generateNewNumber = () => {
    const randomIndex = Math.floor(Math.random() * numbers.numbers.length);
    setCurrentIndex(randomIndex);
  };

  // Randomize on initial load
  useEffect(() => {
    generateNewNumber();
  }, []);

  const number = numbers.numbers[currentIndex];

  return (
    <div className="card hover-lift p-6 group">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500/20 to-cyan-500/20 group-hover:from-blue-500/30 group-hover:to-cyan-500/30 transition-colors">
          <Calculator className="h-6 w-6 text-blue-400" />
        </div>
        <h3 className="text-xl font-semibold gradient-text">Number Encyclopedia</h3>
      </div>
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-blue-500/5 to-cyan-500/5 rounded-lg p-4">
          <h4 className="text-lg font-semibold text-white mb-2">{number.title}</h4>
          <div className="text-3xl font-bold text-blue-400 mb-4">{number.number}</div>
          <ul className="space-y-2">
            {number.facts.slice(0, 3).map((fact, index) => (
              <li key={index} className="text-gray-300 text-sm flex items-start space-x-2">
                <span className="text-blue-400">•</span>
                <span>{fact}</span>
              </li>
            ))}
          </ul>
          <div className="text-sm text-gray-400 mt-4">
            Category: {number.category}
          </div>
        </div>
        <div className="flex justify-between items-center text-sm">
          <div className="flex items-center space-x-2">
            <LikeButton type="number" content={number.title} />
            <ShareButton 
              title="Check out this fascinating number!"
              text={`${number.title} (${number.number}): ${number.facts[0]}`}
            />
          </div>
          <button 
            onClick={generateNewNumber}
            className="text-blue-400 hover:text-blue-300 transition flex items-center space-x-1 group"
          >
            <span>Next Number</span>
            <span className="transform group-hover:translate-x-1 transition-transform">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NumberFacts;